import script from "./SoggettoRichiestaDataDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SoggettoRichiestaDataDialog.vue?vue&type=script&setup=true&lang=js"

import "./SoggettoRichiestaDataDialog.vue?vue&type=style&index=0&id=2bd676c5&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd676c5"]])

export default __exports__